import { sanitizeHtmlString } from "@/common/helpers/html";

export const hasTranslationContent = (value: unknown, isPlainText = false): value is string => {
  if (typeof value !== "string" || !value.trim()) {
    return false;
  }
  if (isPlainText || typeof DOMParser === "undefined") {
    return true;
  }
  const sanitized = sanitizeHtmlString(value.replace(/^LXCL:/, ""));
  if (!sanitized) {
    return false;
  }
  const body = new DOMParser().parseFromString(sanitized, "text/html").body;
  return Boolean(body.textContent?.trim() || body.children.length);
};

export interface TranslationFieldRequest {
  key: string;
  path: string;
  source: string;
  saved?: string | null;
  isPlainText?: boolean;
}

export interface TranslationRowRequest {
  id: string;
  fields: TranslationFieldRequest[];
}
